import generic from './generic'
import toadsworth from './toadsworth'

export default {
    generic,
    toadsworth,
}